module.exports = __webpack_public_path__ + "img/d.fa13bf02.svg";